import * as React from "react";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CloseIcon from "@mui/icons-material/Close";
import GuarantorDocument from "../../../guarantorDocument";
import GuarantorIdentityInfo from "../../../guarantorIdentityInfo";
import GuarantorPlaceInfo from "./guarantorPlaceInfo";
import GuarantorInfo from "./guarantorInfo";
import GuarantorIncomeInfo from "./guarantorIncomeInfo";
import GuarantorInformation from "./guarantorInformation";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function GuarantorDetailModal(props: any) {
  const [open, setOpen] = React.useState<boolean>(props.openModal);
  React.useEffect(() => {
    setOpen(props.openModal);
  }, [props.openModal]);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const handelCancel = () => {
    handleClose();
  };

  return (
    <>
      <MoreHorizIcon
        className="cursorPointer"
        style={{ color: "#9AAFC4" }}
        onClick={handleOpen}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            width: "90%",
            border: "solid 3px #DAE0E4",
            outline: 0,
          }}
          className="tabsScrollModalVehicle"
        >
          <IconButton onClick={handleClose}>
            <CloseIcon
              style={{
                position: "fixed",
                zIndex: "1",
                left: "1vh",
                color: "red",
                top: "1vh",
                background: '#F1F4FF'
              }}
            />
          </IconButton>
          <div>
            <Typography className=" mbottom20">
              <GuarantorDocument data={props} />
              {/* <GuarantorIdentityInfo data={props.data?.identityDocuments} /> */}
              <GuarantorPlaceInfo data={props.data?.residenceDocuments} title={"اطلاعات سکونتی"} postalCode={props.data?.postalCode} inquityAddress={props.data?.inquityAddress} />
              <GuarantorIncomeInfo data={props.data?.incomeDocuments} jobTitle={props.data?.jobTitle} monthlyIncome={props.data?.monthlyIncome} />
              {props.data?.chequeInfo ? <GuarantorInformation data={props.data?.chequeInfo} /> : ""}
            </Typography>
          </div>
        </Box>
      </Modal>
    </>
  );
}
